import VueRouter from 'vue-router'
import { Store } from 'vuex'

export default {
  handler(router: VueRouter, store: Store<any>, error: any) {
    store.set('app/error', 429)
  },
}
